var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87539 17.125C8.72539 16.975 8.65039 16.8 8.65039 16.6C8.65039 16.4 8.72539 16.225 8.87539 16.075L12.9504 12L8.87539 7.92502C8.72539 7.77502 8.65039 7.60002 8.65039 7.40002C8.65039 7.20002 8.72539 7.02502 8.87539 6.87502C9.02539 6.72502 9.20039 6.65002 9.40039 6.65002C9.60039 6.65002 9.77539 6.72502 9.92539 6.87502L14.4254 11.375C14.5087 11.4584 14.5714 11.554 14.6134 11.662C14.6547 11.7707 14.6754 11.8834 14.6754 12C14.6754 12.1167 14.6547 12.229 14.6134 12.337C14.5714 12.4457 14.5087 12.5417 14.4254 12.625L9.92539 17.125C9.77539 17.275 9.60039 17.35 9.40039 17.35C9.20039 17.35 9.02539 17.275 8.87539 17.125Z",
    fill: "#707683"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionRightArrow);
export default __webpack_public_path__ + "static/media/accordion-right-arrow.37cb965f.svg";
export { ForwardRef as ReactComponent };